import createOperationTypeSplitLink from 'src/internal/revamp/links/createOperationTypeSplitLink';

export default createOperationTypeSplitLink;
